import { useEffect } from 'react';
import { loadPlacesLibs } from '../utils/google-places/google-places.utils';

export const useLoadPlacesLibs = () => {
  useEffect(() => {
    loadPlacesLibs();
  }, []);
};
